import React from "react";
// import "../Css/header.css";
import "../Css/bootstrap.min.css";
const Header = () => {
  return (
    <div class="navbar navbar-expand-lg navbar-dark bg-primary">
      <div id="navbar" className="navbar">
      <div class="container-fluid">
    <a class="navbar-brand"/>
        <h1 class="text-light">
        Maple Car
        <span className="text-success">Rent</span>
        
        </h1>
        </div>
      </div>
    </div>
  );
};
export default Header;
